import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/config";
import { onAuthStateChanged } from "firebase/auth";
import { FaSpinner } from "react-icons/fa";

const AdminGuard = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Admin email list (same as in AdminLogin) - moved inside useEffect
    const ADMIN_EMAILS = [
      "admin@banatindia.com",
      "support@banatindia.com",
      "manager@banatindia.com"
    ];

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // Check if user is admin
        const isAdminUser = ADMIN_EMAILS.includes(user.email.toLowerCase());
        const hasAdminSession = localStorage.getItem("adminSession") === "true";
        
        if (isAdminUser && hasAdminSession) {
          setIsAdmin(true);
        } else {
          // Not admin or no session, redirect to admin login
          localStorage.removeItem("adminSession");
          localStorage.removeItem("adminEmail");
          navigate("/admin-login");
        }
      } else {
        // No user logged in, redirect to admin login
        localStorage.removeItem("adminSession");
        localStorage.removeItem("adminEmail");
        navigate("/admin-login");
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  if (loading) {
    return (
      <div className="admin-loading-screen">
        <div className="admin-loading-content">
          <FaSpinner className="loading-spinner" />
          <p>Verifying admin access...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return null; // Will redirect to login
  }

  return children;
};

export default AdminGuard; 